// A checklist does not need section headers. Keep items before the first header
// in an expanded default section rather than dropping them from the display.
export function groupChecklist(items) {
  const groups = [];
  let currentGroup;
  for (const item of items) {
    if (item.isHeader) {
      currentGroup = { header: item.text, items: [] };
      groups.push(currentGroup);
    } else {
      if (!currentGroup) {
        currentGroup = { header: 'Checklist', items: [], ungrouped: true };
        groups.push(currentGroup);
      }
      currentGroup.items.push(item);
    }
  }
  return groups;
}
